import { t } from 'i18next';
import React from 'react';
import { Helmet } from 'react-helmet';

export default function Privacy() {
  return (
    <>
      <Helmet>
        <title>Privacy Policy</title>
      </Helmet>
      <div className="max-w-2xl mx-auto mt-5 top-0 px-6 lg:px-0">
        <div className="bg-white rounded-3xl p-5 md:p-10 shadow-md shadow-black/5">
          <div className="max-w-sm mx-auto">
            <h2 className="font-semibold text-xl text-center mb-5">
              {/* {t('termsAndConditions')} */}
              Privacy Policy
            </h2>
          </div>
          <article className="prose prose-sm prose-h3:text-gray-600 ">
            <h4>Privacy Policy - Consultation and Workshop Services</h4>
            <p>
              This Privacy Policy outlines the practices of Emstell Kuwait Team
              (referred to as "we," "us," or "our") regarding the collection,
              use, storage, and protection of personal and confidential
              information for clients engaging in our consultation and workshop
              services.
            </p>
            <h4>Collection of Information:</h4>
            <p>We may collect the following types of information from you:</p>
            <p>
              Personal Information: This includes your name, contact details,
              and other relevant information necessary for communication and
              service delivery.
            </p>
            <p>
              Business Information: Details related to your business idea,
              requirements, and project details shared during consultations and
              workshops.
            </p>
            <h4>Use of Information:</h4>
            <p>
              Communication: We use your information to communicate with you
              regarding consultations, workshops, and other related matters.
            </p>
            <p>
              Service Delivery: Your information helps us provide effective
              consultation and workshop services tailored to your needs.
            </p>
            <p>
              Workshop Materials: We may use your contact details to send you
              workshop materials, updates, and relevant content.
            </p>
            <h4>Confidentiality and Data Security:</h4>
            <p>
              Data Confidentiality: We treat all business information and
              details you share with us during consultations and workshops as
              strictly confidential.
            </p>
            <p>
              Limitations on Disclosure: We do not share your personal or
              business information with third parties without your explicit
              consent, except as required by law.
            </p>
            <p>
              Data Security: We implement appropriate security measures to
              protect your information from unauthorized access, loss, or
              disclosure.
            </p>
            <h4>Affiliate Links and Third-Party Services:</h4>
            <p>
              Affiliate Links: During sessions, we may use affiliate links to
              recommend certain tools, resources, or services. Clicking on such
              links may result in us receiving a commission, at no additional
              cost to you.
            </p>
            <p>
              Third Party Services: As part of our consultation and workshop
              services, we may engage third-party service providers to enhance
              the quality and effectiveness of our offerings.
            </p>
            <h4>Retention of Information:</h4>
            <p>
              We retain your information only for the duration necessary to
              provide our consultation and workshop services. Afterward, your
              information may be securely archived for record-keeping purposes.
            </p>
            <h4>Your Rights:</h4>
            <p>
              Access and Correction: You have the right to access and correct
              your personal information held by us.
            </p>
            <p>
              Withdrawal of Consent: You can withdraw your consent for the
              collection and use of your information at any time.
            </p>
            <h4>Third Parties:</h4>
            <p>
              We may engage third-party service providers to assist in
              delivering our services. These providers are obligated to maintain
              the confidentiality of your information.
            </p>
            <h4>Changes to Privacy Policy:</h4>
            <p>
              This Privacy Policy may be updated periodically. Any changes will
              be communicated to you through our official communication
              channels.
            </p>
            <h4>Contact Us:</h4>
            <p>
              If you have any questions or concerns about your privacy or our
              data handling practices, please contact us at [contact
              information].
            </p>
            <p>
              By engaging in our consultation and workshop services, you
              acknowledge that you have read, understood, and agreed to this
              Privacy Policy. These terms may be subject to change, and any
              revisions will be communicated to you in advance.
            </p>
            <p>
              Date of Last Update: 08/08/2023 <br />
              Best regards, <br />
              Emstell Kuwait Team
            </p>
          </article>
        </div>
      </div>
    </>
  );
}
